// Colores y labels oficiales del semáforo (mismos que PDFPreview.jsx, no se inventan nuevos)
export const COLOR_HEX = {
  green: '#22c55e',
  blue: '#3b82f6',
  yellow: '#eab308',
  orange: '#f97316',
  red: '#ef4444',
  dark_gray: '#6b7280',
  black: '#1f2937',
  purple: '#a855f7'
};

export const COLOR_LABELS = {
  green: 'Activo con hitos',
  blue: 'Acompañar',
  yellow: 'Activo sin hitos',
  orange: 'Sin actividad',
  red: 'En riesgo',
  dark_gray: 'Inactivo',
  black: 'No iniciado',
  purple: 'Finalizado'
};

export const ACTIONABLE_COLORS = ['green', 'yellow', 'blue', 'orange', 'red', 'dark_gray', 'black'];
export const ALL_COLORS = [...ACTIONABLE_COLORS, 'purple'];

export const ColorDot = ({ color, size = 10 }) => (
  <span
    className="inline-block rounded-full shrink-0"
    style={{ backgroundColor: COLOR_HEX[color] || '#ccc', width: size, height: size }}
    title={COLOR_LABELS[color] || color}
  />
);

export const ColorBadge = ({ color, count, testId }) => (
  <div className="flex items-center gap-2 border rounded-lg px-3 py-2" data-testid={testId}>
    <ColorDot color={color} />
    <div>
      <p className="text-sm font-bold text-gray-900">{count ?? 0}</p>
      <p className="text-xs text-gray-500">{COLOR_LABELS[color] || color}</p>
    </div>
  </div>
);
